import React from "react";
import Transition from "react-transition-group/Transition";
import styled from "react-emotion";

const FadeWrapper = styled("div")`
  transition: opacity ${props => props.duration}ms ease-in-out;
  opacity: 0;
`;

const fadeTransitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 },
};

export const Fade = ({
  in: inProp,
  children,
  timeout = 100,
  duration = 100,
  appear,
  exit,
  style = {},
  ...rest
}) => (
  <Transition in={inProp} timeout={timeout} appear={appear} exit={exit}>
    {state => (
      <FadeWrapper
        duration={duration}
        style={{ ...fadeTransitionStyles[state], ...style }}
        {...rest}
      >
        {children}
      </FadeWrapper>
    )}
  </Transition>
);

const slideTransitionStyles = width => ({
  entering: { transform: `translate(${width}px, 0)` },
  entered: { transform: `translate(0px, 0px)` },
  exiting: { transform: `translate(0px, 0px)` },
  exited: { transform: `translate(${width}px, 0)` },
});

const SlideWrapper = styled("div")`
  transition: transform ${props => props.duration}ms ease-in-out;
  will-change: transform;
`;

export const Slide = ({
  in: inProp,
  children,
  timeout = 0,
  duration = 100,
  width = 450,
  appear,
  exit,
  style = {},
  ...rest
}) => (
  <Transition in={inProp} timeout={timeout} appear={appear} exit={exit}>
    {state => (
      <SlideWrapper
        duration={duration}
        style={{ ...slideTransitionStyles(width)[state], ...style }}
        {...rest}
      >
        {children}
      </SlideWrapper>
    )}
  </Transition>
);



// WEBPACK FOOTER //
// ./src/components/Animations.jsx